import React from 'react';
import can_logo_png from './covid-act-now-logo-url-dark.png';

const LogoDarkWithURL = () => (
  <img src={can_logo_png} alt="Covid Act Now Logo"></img>
);

export default LogoDarkWithURL;
